import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/AboutValues.css';

function AboutValues() {
  const { t } = useTranslation();
  const valuesRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    const valueCards = valuesRef.current?.querySelectorAll('.value-card');
    valueCards?.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = 'all 0.6s ease';
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className='about-values' ref={valuesRef}>
      <div className='values-grid'>
        <div className='value-card'>
          <h3>
            <i className='fa-solid fa-bullseye'></i> {t('values_mission_title')}
          </h3>
          <p>{t('values_mission_text')}</p>
        </div>

        <div className='value-card'>
          <h3>
            <i className='fas fa-eye'></i> {t('values_vision_title')}
          </h3>
          <p>{t('values_vision_text')}</p>
        </div>

        <div className='value-card'>
          <h3>
            <i className='fas fa-solid fa-check'></i> {t('values_values_title')}
          </h3>
          <p>{t('values_values_text')}</p>
        </div>
      </div>
    </div>
  );
}

export default AboutValues;
